<template>
  <!-- 기본 리스트형 -->
  <div class="lsit_box" v-if="postlists.data">
    <!-- 전체 베스트 선택 글쓰기 버튼 -->
    <div class="menu_wrap">
        <ul>
          <!--
            <li>
                <a href="" class="on">전체</a>
            </li>
            <li>
                <a href="">베스트</a>
            </li>
            -->
            <li v-if="!isNotice">
               <a href="javascript:void(0)" @click="linkWrite()">글쓰기</a>
               <!-- <router-link:to="`/main/community/${document}/write`">글쓰기</router-link> -->
            </li>
        </ul>
    </div>
    <!-- 전체 베스트 선택 글쓰기 버튼 --> 

    <!-- 항목 테이블 -->
    <div class="tbl_wrap" >
      <table class="tbl">
        <colgroup>
          <col style="width:15%" />
          <col style="width:53%" />
          <col style="width:19%" />
          <col style="width:7%" />
          <col style="width:7%" />
          <col style="width:6%" />
        </colgroup>
        <thead>
          <tr>
            <th>분류</th>
            <th class="txt-left">제목</th>
            <th class="txt-left">작성자</th>
            <th>등록일</th>
            <th>조회</th>
            <th>추천</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="postlists.data.length ===0">
              <tr><td colspan="6">해당 게시글이 없습니다.</td></tr>
             
          </template>
            <template v-else>
              <tr v-for="(list, index) in postlists.data" :key="index" :class="{'notice':list.notice===1}">
                <td>{{list.document.title}}</td>
                <td class="article_title txt-left">
                  <span v-if="list.notice===1" class="notice_text">[공지]</span><post-title :document="document" :list="list"/>
           
                  <span v-if="list.attachfile"> <font-awesome-icon icon="play-circle" /></span>
                </td>
                <td class="article_writer">
                   <user-name-tag :user="list.user" 
                    :displaymytalk="false" :displayProfileImage="false" />
                </td>
                <td>
                    <display-time :time="list.created_at"/>
                </td>
                <td>{{list.count}}</td>
                <td>{{list.recommend}}</td>
              </tr>   
            </template>

        </tbody>
      </table>
      <paginate store="posts" collection="postsdata" :document="document" />
    </div>
    <!-- 항목 테이블 -->

  </div>
</template>

<script>
import DisplayTime from '@/components/site/parts/DisplayTime.vue'
import Paginate from '@/components/site/parts/Paginate.vue'
import PostTitle from '@/components/posts/PostTitle.vue'
import { auth } from '@/components/mixins/auth.js';

export default {
  props:[
    'document'
  ],
  mixins:[ auth ],
  components:{
    DisplayTime,
    Paginate,
    PostTitle
  }, 
  mounted() {
    this.fetchLists();
    //alert(this.$store.state.menu.activeMenu);
  },
  computed:{
    postlists:{
      get(){
        console.log('포스터 데이터 넘어오는 형식 보기',this.$store.state.posts.postsdata)
        return this.$store.state.posts.postsdata;
      }
    },
    postview(){
      return this.$route.fullpath + '/view/';
    },
    isNotice(){
      //공지사항인지 체크, 유저는 글 작성 못하게하 글쓰게 메뉴 안보이게
      if(this.$store.state.menu.activeSubMenu === "notice")
      {
        return true;
      }else{
        return false;
      }     
    }
  },
  methods:{
    async fetchLists() {
      const formData = {
        document: this.document,
        menu:this.$store.state.menu.activeMenu,
        user_id:this.$store.getters.currentUser.id,
        getmypost:false,
        page:1
       }
      try {
          const response = await this.$store.dispatch("posts/fetchLists", formData)
          //console.log(response);
          this.postlists = response.data.reverse();
          //console.log("안나오는듯",this.postlists.data.length);          
      }catch(error){
          console.log(error.response);
      }
      this.isLoading = false;
    },
    async linkWrite(){
      //아이템 필요한 게시판 체크    
      //조아판 카테고리 게시판은 아이템이 있어야 작성가능
      //const needItemPost =['newgame','infomation','gallery_knowhow'];
      // if(needItemPost.indexOf(this.document) > 0) 게시판 위주로 가게 되면 사용 일단은 메뉴로
      if(this.$store.state.menu.activeMenu === "JoaPan")  
      {
        const ckitem =  await this.ckItem('post_write');
        if(!ckitem){  
          return;                          
        }            
      }     
        this.$router.push({
          path: "/main/community/" + this.document +"/write"
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.lsit_box {
    font-size: 12px;
    .menu_wrap{
        background: #fafafa;
        line-height:70px ;
        ul{
            display:flex;
            li{
                padding:0 13px;
            }
            li:first-child{
                margin-left:10px;
            }
            li:last-child{
                margin-right:30px;
            }
            li:nth-child(2){
                flex:1  auto
            }
        }
    }
  .tbl_wrap {
      padding: 10px 30px 0;
      background:#fff;
      min-height:660px;
    .tbl {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      border-spacing: 0;
      border-bottom: 1px solid #dee3eb;
      margin-bottom: 20px;
      line-height: 51px;
      th {
        color: #a3a3a3;
        border-bottom: 1px solid #dee3eb;
        font-weight: normal;
      }
      td {
        text-align: center;
        border-top: 1px solid #ebeef3;
        color: #a3a3a3;
      }
      .notice{
        background:#fff4f5;
        font-weight:bold; 
        .notice_text{
          color:red;
        }
      }
      .article_title,
      .article_writer {
        color: #000;
        font-weight: normal;
      }

      .txt-left {
        text-align: left !important;
      }
    }
  }
  
}
</style>
